export const Pagination = {
  Page: 1,
  Size: 10,
};
